import { action, observable } from 'mobx';
import { EventId } from '../../../../../commonv3/types/events';
import { SecureUser } from '../../../../../mainv2/types/user';
import { UserEventReservationApis } from '../../../../../mainv2/api/user';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { EventApis } from '../../../../apis/events';
import { EventShowView } from '../../../../types/events';
import { EventWaitlistState } from './EventWaitlistState';

export class DetailsPaneState {
    @observable eventId: EventId;
    @observable event: RemoteResourceV3<EventShowView> = RemoteResourceV3.loading();
    @observable alreadyReserved: boolean = false;
    @observable eventWaitlistState = new EventWaitlistState();

    @action
    async init(eventId: EventId, currentUser?: SecureUser) {
        this.eventId = eventId;
        updateRemoteResourceV3(this.event, (v) => (this.event = v), () => EventApis.find(this.eventId));
        this.eventWaitlistState.init();

        if (currentUser) {
            const userReservations = await UserEventReservationApis.findAll();
            this.alreadyReserved =
                userReservations.find((r) => r.event_type === 'Event' && r.event_id === this.eventId) != null;
        }
    }
}
